import { Button, Form, Input, InputNumber, Radio, TreeSelect } from "antd";
import { useEffect, useState } from "react";
import { useGlobalState } from "../../components/global";

export default function RoleForm({ form, item }: any) {
    const [menuData, setMenu] = useState<any>();
    const { jsonRequest } = useGlobalState();
    const [isCheckAll, setIsCheckAll] = useState(true);
    const [checkedKeys, setCheckedKeys] = useState<any[]>([]);
    const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const handleDropdownVisibleChange = (visible: boolean) => {
        setDropdownVisible(visible);
    };

    const toggleExpand = () => {
        setExpandedKeys(prev => prev.length > 0 ? [] : getAllData(menuData));
        setDropdownVisible(true);
    };

    // 全选全不选
    const checkAll = () => {
        if (isCheckAll) {
            const allKeys = getAllData(menuData);
            setCheckedKeys(allKeys);
            form.setFieldValue('menu', allKeys);
            form.setFieldValue('menuIds', allKeys);
        } else {
            setCheckedKeys([]);
            form.setFieldValue('menu', []);
            form.setFieldValue('menuIds', []);
        }
        setIsCheckAll(!isCheckAll);
        setDropdownVisible(true);
    };

    // 遍历将数据转换为树形结构
    function transfromData(data: any) {
        return data.map((item: any) => {
            const { menuName, id, children } = item;
            const res = { label: menuName, value: id || menuName, key: id || menuName, children: [] };
            if (children && children.length) {
                res.children = transfromData(children);
            }
            return res;
        });
    }

    const handleCheckWithStrategy = (checkedValues: any) => {
        setCheckedKeys(checkedValues);
        const allMenuIds = getAllParentKeys(checkedValues, menuData);
        form.setFieldValue('menu', checkedValues);
        form.setFieldValue('menuIds', allMenuIds);
    };

    // 递归获取所有父级菜单的key
    function getAllParentKeys(checkedKeys: any[], treeData: any[]): any[] {
        const parentKeys = new Set(checkedKeys);

        // 递归查找每个选中节点的所有父节点
        const findParents = (targetKey: any, nodes: any[], path: any[] = []): boolean => {
            for (const node of nodes) {
                const currentPath = [...path, node.value];

                if (node.value === targetKey) {
                    // 找到目标节点，将路径上的所有父节点加入集合
                    currentPath.forEach(key => parentKeys.add(key));
                    return true;
                }

                if (node.children && node.children.length > 0) {
                    if (findParents(targetKey, node.children, currentPath)) {
                        // 如果在子树中找到目标节点，将当前节点也加入父节点集合
                        currentPath.forEach(key => parentKeys.add(key));
                        return true;
                    }
                }
            }
            return false;
        };

        // 为每个选中的节点查找其所有父节点
        checkedKeys.forEach(key => {
            findParents(key, treeData);
        });
        return Array.from(parentKeys);
    }

    // 遍历获取所有数据
    function getAllData(data: any) {
        return data.flatMap((item: any) => {
            const key = item.children ? getAllData(item.children) : [];
            return [...key, item.value];
        });
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                await getMenuData();
                await getDetail();
            } catch (error) {
                console.error('数据获取失败:', error);
            }
        };

        fetchData();
    }, []);

    const getMenuData = async () => {
        jsonRequest.get("/back/sys-menu/tree", {})
            .then((resp: any) => resp.json())
            .then(async ({ data }: any) => {
                const result = transfromData(data);
                setMenu(result);
            });
    };

    function getAllChildrenIds(menuTree: []): any[] {
        let ids: any[] = [];
        menuTree.forEach((menu: any) => {
            if (!menu.children || menu.children.length === 0) {
                ids.push(menu.id);
            } else {
                ids = ids.concat(getAllChildrenIds(menu.children));
            }
        });
        return ids;
    }

    const getDetail = async () => {
        const result = await jsonRequest.get(`/back/sys-role/${item.id}`, {}).then((resp: any) => resp.json());
        const menu = getAllChildrenIds(result.data.menuTrees);
        const menuIds = getAllData(transfromData(result.data.menuTrees));
        form.setFieldsValue({ ...result.data, menuIds: menuIds, menu: menu });
        setCheckedKeys(menu);
    };

    return (
        <Form form={form} size="small" name="role" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} autoComplete="off">
            <Form.Item label="角色名称" name="roleName" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入角色名称" />
            </Form.Item>
            <Form.Item label="排序" name="sortNum" initialValue={0} rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item label="状态" name="status" rules={[{ required: true, message: '不能为空' }]} initialValue="ENABLE">
                <Radio.Group>
                    <Radio value="ENABLE">启用</Radio>
                    <Radio value="DISABLE">禁用</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item label="备注" name="remark">
                <Input.TextArea placeholder="请输入备注信息" autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
            <Form.Item label="菜单权限" name="menu">
                <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px', paddingBottom: '3%' }}>
                    <Button onClick={toggleExpand}>
                        {expandedKeys.length > 0 ? '折叠' : '展开'}
                    </Button>
                    <Button onClick={checkAll}>
                        {isCheckAll ? '全选' : '全不选'}
                    </Button>
                </div>
                <TreeSelect
                    treeData={menuData}
                    multiple
                    allowClear
                    treeCheckable
                    placeholder="请选择菜单权限"
                    showCheckedStrategy="SHOW_ALL"
                    treeExpandedKeys={expandedKeys}
                    value={checkedKeys}
                    onChange={handleCheckWithStrategy}
                    open={dropdownVisible}
                    onTreeExpand={(keys: any) => setExpandedKeys(keys)}
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                />
            </Form.Item>
            <Form.Item label="菜单权限" name="menuIds" hidden >
                <Input />
            </Form.Item>
        </Form>
    )
}